import camelCase from 'lodash/camelCase';
const pModules = {}, qModules = require.context('.', false, /\.js$/);

qModules.keys().forEach(fileName => {
    if(fileName === './index.js') return;
    const moduleName = camelCase(fileName.replace(/(\.\/|\.js)/g, ''));
    pModules[moduleName] = {
        namespaced: true,
        ...qModules(fileName).default
    }
});

export default pModules;